import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import UserService from "../../services/user.service";



export const getUser = createAsyncThunk(
    "user/getUser",
    async (params, thunkAPI) => {
        try {
            const response = await UserService.getUser(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const getunverifiedUser = createAsyncThunk(
    "user/getunverifiedUser",
    async (params, thunkAPI) => {
        try {
            const response = await UserService.getunverifiedUser(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


export const getActivity = createAsyncThunk(
    "user/getActivity",
    async (params, thunkAPI) => {
        try {
            const response = await UserService.getActivity(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


export const getPayment = createAsyncThunk(
    "user/getPayment",
    async (params, thunkAPI) => {
        try {
            const response = await UserService.getPayment(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


export const getSubscription = createAsyncThunk(
    "user/getSubscription",
    async (params, thunkAPI) => {
        try {
            const response = await UserService.getSubscription(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


export const getUserSubscription = createAsyncThunk(
    "user/getUserSubscription",
    async (params, thunkAPI) => {
        try {
            const response = await UserService.getuserSubscription(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const addUser = createAsyncThunk(
    "user/addUser",
    async (data, thunkAPI) => {
        try {
            const response = await UserService.addUser(data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const updateApproveDocument = createAsyncThunk(
    "approvedocuments/updateApproveDocument",
    async (payload, thunkAPI) => {
        try {
            const response = await UserService.editApproveDocument(payload);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const deleteUser = createAsyncThunk(
    "user/deleteUser",
    async (id, thunkAPI) => {
        try {
            await UserService.deleteUser(id);
            return id;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


export const getDashSummary = createAsyncThunk(
    "user/getDashSummary",
    async (params, thunkAPI) => {
        try {
            const response = await UserService.getDashSummary(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const getDashSubscription = createAsyncThunk(
    "user/getDashSubscription",
    async (params, thunkAPI) => {
        try {
            const response = await UserService.getDashSubscription(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const getDashData = createAsyncThunk(
    "user/getDashData",
    async (params, thunkAPI) => {
        try {
            const response = await UserService.getDashData(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const getDashRegistartion = createAsyncThunk(
    "user/getDashRegistartion",
    async (params, thunkAPI) => {
        try {
            const response = await UserService.getDashRegistartion(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);



const initialState = {
    loading: false,
    error: null,

    userlist: [],
    unverifieduserlist: [],
    activityList: [],
    paymentList: [],
    subscriptionList: [],

    // ✅ NEW
    summaryData: [],
    subscriberData: [],
    salesData: [],
    dashStats: {},

    updateSuccess: false,
    userSubscription: null,
};
const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        resetUpdateStatus: (state) => {
            state.updateSuccess = false;
        },
    },
    extraReducers: (builder) => {
        builder

            /* ---------- Get ---------- */
            .addCase(getUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUser.fulfilled, (state, action) => {
                state.loading = false;
                state.userlist = action.payload?.data || [];
            })
            .addCase(getUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })


            .addCase(getunverifiedUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getunverifiedUser.fulfilled, (state, action) => {
                state.loading = false;
                state.unverifieduserlist = action.payload?.data || [];
            })
            .addCase(getunverifiedUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            /* ---------- Activity ---------- */
            .addCase(getActivity.pending, (state) => {
                state.loading = true;
            })
            .addCase(getActivity.fulfilled, (state, action) => {
                state.loading = false;
                state.activityList = action.payload?.data || [];
            })
            .addCase(getActivity.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            /* ---------- Payment ---------- */
            .addCase(getPayment.pending, (state) => {
                state.loading = true;
            })
            .addCase(getPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.paymentList = action.payload?.data || [];
            })
            .addCase(getPayment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            /* ---------- Subscription ---------- */
            .addCase(getSubscription.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSubscription.fulfilled, (state, action) => {
                state.loading = false;
                state.subscriptionList = action.payload?.data || [];
            })
            .addCase(getSubscription.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(getUserSubscription.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUserSubscription.fulfilled, (state, action) => {
                state.loading = false;
                state.userSubscription = action.payload?.data || null;
            })
            .addCase(getUserSubscription.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.userSubscription = null;
            })

            .addCase(getDashSummary.fulfilled, (state, action) => {
                state.summaryData = action.payload?.summaryData || [];
            })



            .addCase(getDashSubscription.fulfilled, (state, action) => {
                state.subscriberData = action.payload?.subscriberData || [];
            })
            .addCase(getDashRegistartion.fulfilled, (state, action) => {
                state.salesData = action.payload?.salesData || [];
            })
            .addCase(getDashData.fulfilled, (state, action) => {
                state.dashStats = action.payload?.data || {};
            })
            /* ---------- Add ---------- */
            .addCase(addUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addUser.fulfilled, (state, action) => {
                state.loading = false;

                const newUser =
                    action.payload?.data ||
                    action.payload?.userData ||
                    action.payload;

                if (newUser) {
                    state.userlist.unshift(newUser);
                }
            })
            .addCase(addUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            /* ---------- Update ---------- */
            .addCase(updateApproveDocument.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.updateSuccess = false;
            })
            .addCase(updateApproveDocument.fulfilled, (state, action) => {
                state.loading = false;
                state.updateSuccess = true;
                const updated =
                    action.payload?.data || action.payload?.userData;
                if (updated?._id && Array.isArray(state.userlist)) {
                    const index = state.userlist.findIndex(
                        (item) => item._id === updated._id
                    );
                    if (index !== -1) { state.userlist[index] = updated; }
                }
            })
            .addCase(updateApproveDocument.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            /* ---------- Delete ---------- */
            .addCase(deleteUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteUser.fulfilled, (state, action) => {
                state.loading = false;
                state.userlist = state.userlist.filter(
                    (item) => item._id !== action.payload
                );
            })
            .addCase(deleteUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetUpdateStatus } = userSlice.actions;
export default userSlice.reducer;
